import { Popover, Select, Text, UnstyledButton } from '@mantine/core';
import { useState } from 'react';
import { useAssignees, useAssignLead } from '@/models/leads';
import { UserAvatar } from '@/components/UserAvatar';

export function AssignAssigneeControl(props: {
  leadId: number;
  assigneeUserId: number | null;
  assigneeLabel?: string | null;
  assigneePicture?: string | null;
  readOnly?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const { data } = useAssignees(!props.readOnly);
  const mutate = useAssignLead();

  const assignee = data?.users.find((u) => u.id === props.assigneeUserId);
  const name = assignee?.info?.name || props.assigneeLabel || null;
  const email = assignee?.email || null;
  const picture = assignee?.info?.picture || props.assigneePicture || null;

  if (props.assigneeUserId == null && props.readOnly) {
    return (
      <Text size="sm" c="dimmed">
        Unassigned
      </Text>
    );
  }

  const options = (data?.users ?? []).map((u) => ({
    value: String(u.id),
    label: u.info?.name || u.email,
  }));
  options.unshift({ value: '', label: 'Unassigned' });

  const select = (
    <Select
      data={options}
      value={props.assigneeUserId == null ? '' : String(props.assigneeUserId)}
      onChange={(v) => {
        const assigneeUserId = v ? Number(v) : null;
        mutate.mutate({ leadId: props.leadId, assigneeUserId });
        setOpen(false);
      }}
      searchable
    />
  );

  if (props.assigneeUserId == null) {
    return (
      <Popover
        opened={open}
        onChange={setOpen}
        position="bottom-start"
        withArrow
      >
        <Popover.Target>
          <UnstyledButton onClick={() => setOpen((v) => !v)}>
            <Text size="sm" c="dimmed">
              Unassigned
            </Text>
          </UnstyledButton>
        </Popover.Target>
        <Popover.Dropdown>{select}</Popover.Dropdown>
      </Popover>
    );
  }

  if (props.readOnly) {
    return <UserAvatar name={name} email={email} picture={picture} />;
  }

  return (
    <Popover opened={open} onChange={setOpen} position="bottom-start" withArrow>
      <Popover.Target>
        <UnstyledButton onClick={() => setOpen((v) => !v)}>
          <UserAvatar name={name} email={email} picture={picture} />
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown>{select}</Popover.Dropdown>
    </Popover>
  );
}
